import { render } from "./DkBot.vue?vue&type=template&id=391db988"
import script from "./DkBot.vue?vue&type=script&lang=js"
export * from "./DkBot.vue?vue&type=script&lang=js"

import "./DkBot.vue?vue&type=style&index=0&id=391db988&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__